import { Block, Typography } from '@xprog/prensa'
import SearchInput from 'components/SearchInput/SearchInput.index'
import { FilterContext } from 'providers/Filter'
import { FilterDataContext } from 'providers/FilterData'
import { useRouter } from 'next/router'
import React, { useContext, useState } from 'react'

const SearchInputBox: React.FC<any> = ({
  css,
  hasItemsIndicator = true,
  id,
  buttonId,
  slotTemplateCode
}) => {
  const urlParams = new URLSearchParams(window.location.search)
  const termParam = urlParams.get('term') || ''
  const router = useRouter()
  const [term, setTerm] = useState(termParam)
  const filterContext = useContext(FilterContext)
  const filterDataContext = useContext(FilterDataContext)
  const templateData = filterDataContext.collections[slotTemplateCode]
  const templateTotalItems = templateData?.totalItems || 0
  
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTerm(event.target.value)
    filterContext.updateFilter(slotTemplateCode, { term: event.target.value })
  }

  const handleSearch = () => {
    const url = `/pesquisa?term=${term}`
    router.push(url)
  }

  const styles = {
    container: { m: '$0', mb: '$6', width: '100%' },
    input: {
      ml: '$3',
      width: 'calc(100% - $6)',
      '@lg': {
        m: '$0',
        width: '100%'
      }
    },
    icon: {
      button: {
        right: '$6',
        '@lg': {
          right: '$3'
        }
      }
    }
  }

  return (
    <Block css={{ width: '100%' }}>
      <SearchInput
        id={id}
        buttonId={buttonId}
        onChange={handleChange}
        onSearch={handleSearch}
        value={term}
        css={{ ...styles, ...css }}
      />
      {hasItemsIndicator &&
        <Typography
          as='p'
          css={{ fontSize: '22px', mb: '$8' }}
          variant='sectionTitle-default'
        >
          Foram encontrados {templateTotalItems} resultados:
        </Typography>
      }
    </Block>
  )
}

export default SearchInputBox
